export type LookupErrorCode = 'ARTIFACT_NOT_FOUND' | 'INTERNAL_ERROR';

const MESSAGES: Record<LookupErrorCode, string> = {
  ARTIFACT_NOT_FOUND: 'No artifact or metrics available',
  INTERNAL_ERROR: 'Something went wrong, please try again',
};

/**
 * Classifies a failed lookup request's HTTP status into one of two user-facing
 * categories (spec FR-1.1). Only for a request that was actually attempted —
 * a missing identifier (no request made at all) is always ARTIFACT_NOT_FOUND
 * regardless of this function; callers must check that separately (FR-1.2)
 * before falling back to this classifier.
 */
export const classifyLookupFailure = (status: number | undefined): LookupErrorCode =>
  status === 404 ? 'ARTIFACT_NOT_FOUND' : 'INTERNAL_ERROR';

/** Fixed, English-only user-facing message for a classified lookup error code (spec FR-1.3). */
export const getLookupErrorMessage = (code: LookupErrorCode): string => MESSAGES[code];
